import actions from './actions.svg';
import alert from './alert.svg';
import analyzer from './analyzer.svg';
import approve from './approve.svg';
import arrowDown from './arrow-down.svg';
import arrowLeft from './arrow-left.svg';
import arrowRight from './arrow-right.svg';
import arrowUp from './arrow-up.svg';
import attachment from './attachment.svg';
import boolean from './boolean.svg';
import briefcase from './briefcase.svg';
import checklist from './checklist.svg';
import checkmarkCircledFilled from './checkmark-circled-filled.svg';
import checkmark from './checkmark.svg';
import chevronDown from './chevron-down.svg';
import chevronLeft from './chevron-left.svg';
import chevronRight from './chevron-right.svg';
import chevronUp from './chevron-up.svg';
import chip from './chip.svg';
import close from './close.svg';
import code from './code.svg';
import coloredDocumentDoc from './colored-document-doc.svg';
import coloredDocumentExcel from './colored-document-excel.svg';
import coloredDocumentImage from './colored-document-image.svg';
import coloredDocumentMusic from './colored-document-music.svg';
import coloredDocumentOutline from './colored-document-outline.svg';
import coloredDocumentPdf from './colored-document-pdf.svg';
import coloredDocumentSlideshow from './colored-document-slideshow.svg';
import coloredDocumentVideo from './colored-document-video.svg';
import coloredUserAvatar from './colored-user-avatar.svg';
import condition from './condition.svg';
import copyClipboard from './copy-clipboard.svg';
import dash from './dash.svg';
import dashboard from './dashboard.svg';
import department from './department.svg';
import documentGroups from './document-groups.svg';
import documentOutline from './document-outline.svg';
import donut from './donut.svg';
import dotLarge from './dot-large.svg';
import dot from './dot.svg';
import download from './download.svg';
import drive from './drive.svg';
import edit from './edit.svg';
import email from './email.svg';
import expand from './expand.svg';
import expiring from './expiring.svg';
import fieldAddress from './field-address.svg';
import fieldAttachment from './field-attachment.svg';
import fieldDate from './field-date.svg';
import fieldDropdown from './field-dropdown.svg';
import fieldEmail from './field-email.svg';
import fieldMonetary from './field-monetary.svg';
import fieldMultipleChoice from './field-multiple-choice.svg';
import fieldNumber from './field-number.svg';
import fieldParagraph from './field-paragraph.svg';
import fieldPercentage from './field-percentage.svg';
import fieldRadio from './field-radio.svg';
import fieldReference from './field-reference.svg';
import fieldShortResponse from './field-short-response.svg';
import fieldTimePeriod from './field-time-period.svg';
import field from './field.svg';
import filter from './filter.svg';
import flag from './flag.svg';
import folderOutline from './folder-outline.svg';
import folder from './folder.svg';
import gear from './gear.svg';
import help from './help.svg';
import history from './history.svg';
import inbox from './inbox.svg';
import info from './info.svg';
import key from './key.svg';
import leftSidebarHide from './left-sidebar-hide.svg';
import leftSidebarShow from './left-sidebar-show.svg';
import library from './library.svg';
import lightbulb from './lightbulb.svg';
import link from './link.svg';
import listLookup from './list-lookup.svg';
import loadFrom from './load-from.svg';
import loadingSpinner from './loading-spinner.svg';
import lock from './lock.svg';
import mention from './mention.svg';
import message from './message.svg';
import mosaic from './mosaic.svg';
import move from './move.svg';
import note from './note.svg';
import notificationList from './notification-list.svg';
import notificationOff from './notification-off.svg';
import notification from './notification.svg';
import panel from './panel.svg';
import pauseCircle from './pause-circle.svg';
import plusCircle from './plus-circle.svg';
import plus from './plus.svg';
import reauthenticate from './reauthenticate.svg';
import reconnect from './reconnect.svg';
import reject from './reject.svg';
import reload from './reload.svg';
import remove from './remove.svg';
import reorder from './reorder.svg';
import report from './report.svg';
import rerun from './rerun.svg';
import returnArrow from './return-arrow.svg';
import review from './review.svg';
import saveAlternate from './save-alternate.svg';
import saveAsVersion from './save-as-version.svg';
import saveTo from './save-to.svg';
import search from './search.svg';
import selectFiles from './select-files.svg';
import shareAlternate from './share-alternate.svg';
import share from './share.svg';
import signature from './signature.svg';
import sort from './sort.svg';
import sparkle from './sparkle.svg';
import spinner from './spinner.svg';
import startCircle from './start-circle.svg';
import stop from './stop.svg';
import subArrow from './sub-arrow.svg';
import sync from './sync.svg';
import textHighlight from './text-highlight.svg';
import timelapse from './timelapse.svg';
import trash from './trash.svg';
import unknownUser from './unknown-user.svg';
import unlink from './unlink.svg';
import up from './up.svg';
import uploadPaper from './upload-paper.svg';
import upload from './upload.svg';
import user from './user.svg';
import view from './view.svg';
import visitLink from './visit-link.svg';
import warning from './warning.svg';
import workflow from './workflow.svg';
import wrench from './wrench.svg';

export const icons = {
  actions,
  alert,
  analyzer,
  approve,
  arrowDown,
  arrowLeft,
  arrowRight,
  arrowUp,
  attachment,
  boolean,
  briefcase,
  checklist,
  checkmark,
  checkmarkCircledFilled,
  chevronDown,
  chevronLeft,
  chevronRight,
  chevronUp,
  chip,
  close,
  code,
  coloredDocumentDoc,
  coloredDocumentExcel,
  coloredDocumentImage,
  coloredDocumentMusic,
  coloredDocumentOutline,
  coloredDocumentPdf,
  coloredDocumentSlideshow,
  coloredDocumentVideo,
  coloredUserAvatar,
  condition,
  copyClipboard,
  dash,
  dashboard,
  department,
  documentGroups,
  documentOutline,
  donut,
  dotLarge,
  dot,
  download,
  drive,
  edit,
  email,
  expand,
  expiring,
  fieldAddress,
  fieldAttachment,
  fieldDate,
  fieldDropdown,
  fieldEmail,
  fieldMonetary,
  fieldMultipleChoice,
  fieldNumber,
  fieldParagraph,
  fieldPercentage,
  fieldRadio,
  fieldReference,
  fieldShortResponse,
  fieldTimePeriod,
  field,
  filter,
  flag,
  folder,
  folderOutline,
  gear,
  help,
  history,
  inbox,
  info,
  key,
  leftSidebarHide,
  leftSidebarShow,
  library,
  lightbulb,
  link,
  listLookup,
  loadFrom,
  loadingSpinner,
  lock,
  mention,
  message,
  move,
  mosaic,
  note,
  notificationList,
  notificationOff,
  notification,
  panel,
  pauseCircle,
  plusCircle,
  plus,
  reauthenticate,
  reload,
  reject,
  remove,
  reorder,
  report,
  rerun,
  returnArrow,
  review,
  saveAlternate,
  saveAsVersion,
  saveTo,
  search,
  selectFiles,
  shareAlternate,
  share,
  signature,
  sort,
  sparkle,
  spinner,
  stop,
  startCircle,
  subArrow,
  sync,
  textHighlight,
  timelapse,
  trash,
  reconnect,
  unknownUser,
  unlink,
  up,
  upload,
  uploadPaper,
  user,
  view,
  visitLink,
  warning,
  workflow,
  wrench,
};
